export {};

/**
 * Переключаемые чипсы.
 * Тут все обработчики для них.
 */

const simpleSwitchableChipHandler = function ($chip, mode)
{
    const $input = $chip.find('input');
    const $otherChips = $chip.siblings();

    if ($input.prop('checked')) {
        if (mode === 'single') {
            $otherChips.find('.js-filter-chip:checked').prop('checked', false);
        } else {
            $otherChips.find('.js-switchable-chip-reset').prop('checked', false);
        }

        $input.trigger('switchable_chip:change');
    }

    if (!$input.prop('checked')) {
        const $checkedOtherChips = $otherChips.find('input:not(.js-switchable-chip-reset):checked');

        if ($checkedOtherChips.length === 0) {
            $otherChips.find('.js-switchable-chip-reset').prop('checked', true);
        }
    }
};

const resetSwitchableChipHandler = function ($chip)
{
    const $input = $chip.find('input');
    const $otherChips = $chip.siblings();

    if ($input.prop('checked')) {
        $otherChips.find('input').prop('checked', false);
    }

    if (!$input.prop('checked')) {
        const $checkedOtherChips = $otherChips.find('input:not(.js-switchable-chip-reset):checked');

        if ($checkedOtherChips.length === 0) {
            $input.prop('checked', true);
        }
    }

    $input.trigger('switchable_chip:change');
};

$(document).on('click', '.switchable-chip', function ()
{
    const $chip = $(this);
    const $input = $chip.find('input');
    const isResetChip = $input.hasClass('js-switchable-chip-reset');
    const mode = $chip.hasClass('switchable-chip__single-mode') ? 'single' : 'multiple';

    if (isResetChip) {
        resetSwitchableChipHandler($chip);
    } else {
        simpleSwitchableChipHandler($chip, mode)
    }
});


// WEBPACK FOOTER //
// ./js/main/module/switchable-chip.js